import { lazy } from "react";

import { RoutePathBuilder } from "@/common/builders/routePath";
import { Loadable } from "@/common/components/Loadable";
import AppRoute from "@/common/components/Routing/AppRoute";
import { ROUTE_PATH } from "@/common/constants/routing";

const Profile = Loadable(lazy(() => import("../../BaseApp/Profile/Profile")));
const ProfilePersonalInfoEdit = Loadable(
  lazy(() => import("../../BaseApp/Profile/ProfilePersonalInfoEdit")),
);
const ProfileSettingsEdit = Loadable(
  lazy(() => import("../../BaseApp/Profile/ProfileSettingsEdit")),
);

export function ProfileRoutes() {
  return (
    <>
      <AppRoute
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.FLEET_PROFILE_VIEW)}
        render={() => <Profile />}
      />
      <AppRoute
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.FLEET_PROFILE_PERSONAL_INFO_EDIT)}
        render={() => <ProfilePersonalInfoEdit />}
      />
      <AppRoute
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.FLEET_PROFILE_SETTINGS_EDIT)}
        render={() => <ProfileSettingsEdit />}
      />
    </>
  );
}
